import './PortBottomLayout.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Divider } from 'antd'
import Emblem from '../../images/widget/emblem.png'

export default class PortBottomLayout extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  render() {
    return (
      <div className="PortBottomLayout">
        <Divider style={{ borderColor: 'gray', height: 10 }} />

        <div className="PortBottomMenuWrapper">
          <div className="PortBottomMenu">
            <div className="PortBottomMenuTitle">法律</div>
            <div
              className="PortBottomMenuItem"
              onClick={() => this.viewContractTerms()}
            >
              Keystride条款与条件
            </div>
          </div>
        </div>

        <Divider
          style={{ borderColor: 'gray', height: 10, marginBottom: '1vh' }}
        />

        <div
          className="PortDomain"
          onClick={() => {
            window.open(
              'https://beian.miit.gov.cn/#/Integrated/index',
              '_blank'
            )
          }}
        >
          <div className="PortDomainCopyright">
            版权所有 © 2025 江苏凯士达阀门科技有限公司保留所有权
          </div>
          <div className="PortDomainGonganBeian">
            <img className="PortDomainGonganBeianEmblem" src={Emblem} />
            <div
              className="PortDomainGonganBeianTitle"
              onClick={() => {
                window.open(
                  'https://beian.mps.gov.cn/#/query/webSearch?code=32118202001106',
                  '_blank'
                )
              }}
            >
              苏公网安备32118202001106号
            </div>
          </div>
          <div
            className="PortDomainIcpBeian"
            onClick={() => {
              window.open(
                'https://beian.miit.gov.cn/#/Integrated/index',
                '_blank'
              )
            }}
          >
            苏ICP备2025182856号-1
          </div>
        </div>
      </div>
    )
  }

  viewContractTerms = () => {
    this.props.history.push('/contract_terms')
  }
}
